/**
 * Register the offline-shell service worker (§24.5). Guarded so the app runs unchanged in
 * environments without service-worker support (SSR, tests, older browsers, non-secure origins).
 * Registration failures are swallowed — the console works online regardless.
 */
export function registerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Offline shell is a progressive enhancement; ignore registration failures.
    });
  });
}
